import React, { useCallback } from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
//
import { AddCircleIcon } from 'refactored/ui/icons';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import routes from 'utils/routes';
import { actions as orderActions } from 'state/order';
import orderConstants from 'utils/order/constants';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import { useTranslation } from 'react-i18next';

const IconContainer = styled.div`
  width: 20px;
  height: 20px;
  flex: none;
  order: 0;
  flex-grow: 0;
  display: flex;
`;

const TextContainer = styled.div`
  /* Container */

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 8px;

  height: 16px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
  width: 100%;
  height: 16px;

  /* 14px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  /* primary/500 */

  color: #0140cd;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
`;

const SoFormAddShippmentButton = ({ className }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('Catalog');

  const onClick = useCallback(() => {
    dispatch(
      analyticsActions.sendEvent(
        analyticsEvents.form.orderTypeChanged({
          type: orderConstants.DISTRIBUTION,
        })
      )
    );
    dispatch(orderActions.setTypeOrder({ type: orderConstants.DISTRIBUTION }));
    dispatch(push(routes.newOrder));
  }, [dispatch]);
  return (
    <button className={className} onClick={onClick}>
      <IconContainer>
        <AddCircleIcon />
      </IconContainer>
      <TextContainer>{t('configuration.add_stop')}</TextContainer>
    </button>
  );
};

SoFormAddShippmentButton.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 0px;
  gap: 8px;

  height: 36px;

  border-radius: 4px;

  /* Inside auto layout */

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;

  background: transparent;
  border: none;
  outline: none;
  /* background: red; */
  cursor: pointer;
  /* border: 1px solid black; */
  margin-top: 8px;
`;

export default styled(SoFormAddShippmentButton)`
  ${regularCSS}
`;
